import axios from "axios";
import api from "./axios";

export const getQuestions = async (filters = {}) => {
    const {subjectId, examBaseId, questionText, assignedOnly, pageNo = 1, pageSize = 10} = filters;

    const params = {};

    if (subjectId !== undefined && subjectId !== null && subjectId !== "") {
        params.subjectId = subjectId;
    }

    if (examBaseId !== undefined && examBaseId !== null && examBaseId !== "") {
        params.examBaseId = examBaseId;
    }

    if (assignedOnly !== undefined && assignedOnly !== null) {
        params.assignedOnly = assignedOnly;
    }

    if (questionText && questionText.trim().length > 0) {
        params.text = questionText.trim();
    }

    params.pageNo = pageNo;
    params.pageSize = pageSize;

    const res = await api.get(`/questions`, {
        params,
    });
    return res.data;
};

export const getQuestionsByExamBase = async (examBaseId, params = {}) => {
    const res = await api.get(`/exam-bases/${examBaseId}/questions`, {
        params,
    });
    return res.data;
};

const appendOptionFiles = (formData, optionFiles) => {
    if (!optionFiles) return;
    Object.keys(optionFiles).forEach((idx) => {
        const f = optionFiles[idx];
        if (f) {
            formData.append(`optionFile_${idx}`, f);
        }
    });
};

export const createQuestion = async (payload, file, optionFiles) => {
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    if (file) {
        formData.append("file", file);
    }
    appendOptionFiles(formData, optionFiles);

    const res = await api.post(`/questions`, formData);
    return res.data;
};

export const createQuestionByExamBase = async (examBaseId, payload, file, optionFiles) => {
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    if (file) {
        formData.append("file", file);
    }
    appendOptionFiles(formData, optionFiles);

    const res = await api.post(`/exam-bases/${examBaseId}/questions`, formData);
    return res.data;
};

export const updateQuestion = async (payload, file, optionFiles, force) => {
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    if (file) {
        formData.append("file", file);
    }
    appendOptionFiles(formData, optionFiles);

    let url = `/questions`
    if (force === true) {
        url += `?force=${force}`;
    }

    const res = await api.put(url, formData);
    return res.data;
};

export const updateQuestionByExamBase = async (examBaseId, payload, file, optionFiles, force) => {
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    if (file) {
        formData.append("file", file);
    }
    appendOptionFiles(formData, optionFiles);

    let url = `/exam-bases/${examBaseId}/questions`
    if (force === true) {
        url += `?force=${force}`;
    }

    const res = await api.put(url, formData);
    return res.data;
};

export const deleteQuestionByExamBase = async (examBaseId, questionId, forceDelete) => {
    let url = `/exam-bases/${examBaseId}/questions/${questionId}`
    if (forceDelete === true) {
        url += `?force=${forceDelete}`;
    }
    const res = await api.delete(url);
    return res.data;
};

export const deleteQuestion = async (questionId, forceDelete) => {
    let url = `/questions/${questionId}`
    if (forceDelete === true) {
        url += `?force=${forceDelete}`;
    }
    const res = await api.delete(url);
    return res.data;
};

// --- Cloudflare Stream video explanation (direct creator upload) ---

// Ask our backend to reserve a one-time Cloudflare upload URL. Returns { uid, uploadUrl }.
export const createQuestionVideoUpload = async () => {
    const res = await api.post(`/questions/video/direct-upload`);
    return res.data;
};

// Upload the video file straight to Cloudflare (bypasses the backend's small multipart limit).
// Uses bare axios so the app's auth/baseURL interceptors are not applied to the external URL.
export const uploadVideoToCloudflare = async (uploadUrl, file, onProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    await axios.post(uploadUrl, formData, {
        onUploadProgress: (evt) => {
            if (onProgress && evt.total) {
                onProgress(Math.round((evt.loaded * 100) / evt.total));
            }
        },
    });
};
